import React, { FC, useMemo } from 'react';
import { Team } from 'api/models';
import { PlaceholderAvatar } from 'components/molecules/placeholder-avatar';
import { useRolesQuery } from 'queries/roles';
import { DescriptionWithAvatar } from './description-with-avatar';

export const TeamDetail: FC<{ team: Team }> = ({ team }) => {
  const { data: roles = [] } = useRolesQuery();
  const role = useMemo(
    () => roles.find((x) => x.roleId === team?.roleId),
    [team, roles],
  );

  return (
    <DescriptionWithAvatar
      avatar={
        <PlaceholderAvatar
          isCustomerRole={false}
          size="large"
          name={team.teamName}
        />
      }
      title={team.teamName}
      subtitle={role?.roleName}
    />
  );
};
